import { Pipe, PipeTransform } from '@angular/core';

import { ConstantsService } from '../core/upgraded-providers';

@Pipe({
    name: 'powersKeys'
})
export class PowersKeysPipe implements PipeTransform {
    constructor(
        private _CONSTANTS: ConstantsService
    ) {
    }

    transform(powers: any, _className: string): any {
        return Object.entries<IPower>(this._CONSTANTS.POWER_INFO).filter(([, { className }]) => {
            return className === _className;
        }).sort(([, a], [, b]) => {
            return a.level[0] - b.level[0];
        }).map(([key]) => key).filter((key) => {
            return powers[key];
        });
    }
}
